export interface DeleteRequest {

  ContractorId: string;
  AssessmentId: string;
  AnswerId: string;
  FileNames: string[];
}
